import { useMemo } from 'react';
import { usePermission, useHasAnyPermission } from './usePermission';
import { PRODUCT_PERMISSIONS } from '../constants/permissions.constants';

const MANAGEMENT_PERMISSIONS = [
  PRODUCT_PERMISSIONS.ADD,
  PRODUCT_PERMISSIONS.EDIT,
  PRODUCT_PERMISSIONS.DELETE,
  PRODUCT_PERMISSIONS.EXPORT,
  PRODUCT_PERMISSIONS.DUPLICATE,
] as const;

/**
 * Permisos del menú Catálogo de Productos.
 * Solo lectura: view + view_row. Gestión completa: cualquier permiso de edición/alta/borrado.
 */
export function useProductCatalogPermissions() {
  const canViewMenu = usePermission(PRODUCT_PERMISSIONS.VIEW);
  const canViewRow = usePermission(PRODUCT_PERMISSIONS.VIEW_ROW);
  const canManage = useHasAnyPermission([...MANAGEMENT_PERMISSIONS]);

  return useMemo(
    () => ({
      canViewMenu,
      canViewRow,
      canManage,
      canAdd: canManage,
      canExport: canManage,
      canDelete: canManage,
      canEdit: canManage,
      canDuplicate: canManage,
    }),
    [canViewMenu, canViewRow, canManage],
  );
}
